import { cap } from '../../State'
import { translations } from '../../translations'
import { Modal } from '..'
const language = cap.language.state || 'IT'
const t = translations[language]
export const ConfirmModal = ({ visible, header, label, onConfirm }) => {
  const [modalVisible, setModalVisible] = visible
  return (
    <Modal
      visible={modalVisible}
      header={header}
      onHide={() => setModalVisible(false)}
      className="nora-dialog"
      contentStyle={{ padding: 0 }}
      style={{ width: 'min(460px, 92vw)' }}
    >
      <div className="nora-dialog__body--compact">
        <div className="nora-dialog__confirm">
          <span className="nora-dialog__icon" aria-hidden="true">
            <i className="pi pi-info-circle" style={{ fontSize: 18 }} />
          </span>
          <p className="nora-dialog__message">{label}</p>
        </div>
      </div>
      <div className="nora-dialog__body nora-dialog__footer">
        <button type="button" className="nbtn" onClick={() => setModalVisible(false)}>
          {t.annulla}
        </button>
        <button
          type="button"
          className="nbtn nbtn--primary"
          onClick={() => {
            onConfirm()
            setModalVisible(false)
          }}
        >
          {t.conferma}
        </button>
      </div>
    </Modal>
  )
}
